import React from "react";
import { FacebookShareButton, FacebookIcon } from "react-share";

const FacebookShare = (props) => {
  let url = props.url !== undefined ? props.url : "http://nokarinepal.com";
  let quote = props.quote !== undefined ? props.quote : "";
  let hashtag = props.hashtag !== undefined ? props.hashtag : "#nokarinepal";
  return (
    <FacebookShareButton
      url={url}
      quote={quote}
      hashtag={hashtag}
    >
      <FacebookIcon size={30} />
    </FacebookShareButton>
  );
};

export default FacebookShare;
